// src/App.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import AppRouter from "./routes/AppRouter";
import { jwtDecode } from "jwt-decode";
import "./App.css";

const App = () => {
  const navigate = useNavigate();
  const { token, logout, refreshToken } = useAuth();

  useEffect(() => {
    const checkTokenExpiration = () => {
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime - 60) {
          // 1 minuto de margen
          refreshToken().catch(() => {
            logout();
            navigate("/login");
          });
        }
      } catch (error) {
        logout();
        navigate("/login");
      }
    };

    const interval = setInterval(checkTokenExpiration, 300000); // Cada 5 minutos
    return () => clearInterval(interval);
  }, [token, logout, navigate, refreshToken]);

  return <AppRouter />;
};

export default App;
